import React, { FC, useState } from 'react';

import { SquaresIcon } from '../icons/squares';
import { Button } from '../../shared/ui';

interface IProps {
  id: number;
  text: string;
  btnText?: string;
  cardName: string;
  isBlocked: boolean;
  selected: string[];
  setSelected: React.Dispatch<React.SetStateAction<string[]>>;
}

const ToolsCard: FC<IProps> = ({ id, text, btnText = 'Голосовать', cardName, isBlocked, selected, setSelected }) => {
  const [hover, setHover] = useState(false);
  const iri = `/api/v1/psy-tools/${id}`;
  const isChosen = selected.includes(iri);

  return (
    <>
      <div
        className="w-full h-[180px] flex items-center justify-center bg-white mb-[15px] border border-accent rounded-control relative pt-[42px]"
        onMouseMove={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <div className="w-full h-[42px] flex items-center justify-center absolute top-0 left-0 p-[5px] bg-accent text-ui-xs-strong text-ink rounded-t-control text-center">
          {cardName}
        </div>
        {!hover && <SquaresIcon fill="#C00000" needHover={false} />}
        {hover && <div className="text-ui-xs text-ink px-[5px] text-center">{text}</div>}
      </div>
      <Button
        size="md"
        variant={isChosen ? 'muted' : 'primary'}
        aria-pressed={isChosen}
        disabled={isBlocked}
        fullWidth
        onClick={() => setSelected((prev) => (prev.includes(iri) ? prev.filter((el) => el !== iri) : [...prev, iri]))}
      >
        {isChosen ? 'Мой выбор' : btnText}
      </Button>
    </>
  );
};

export default ToolsCard;
